import React, {useState} from "react";
import {Button, Descriptions, Form, Input} from "antd";

const MX = Form.create({name: 'mx_account_edit'})(({ account, form, save, close }) => {
  const [loading, setLoading] = useState(false);
  const clabe = account.meta ? (account.meta.clabe || '') : '';
  const cacao_id = account.meta ? (account.meta.cacao_id || '') : '';

  const onSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        save(values).then(
          result => close(true),
          error => setLoading(false),
        );
      }
    });
  };

  return (
    <>
      <Descriptions bordered title={account.alias}>
        <Descriptions.Item label="Account Level" span={3}>
            {account.level}
        </Descriptions.Item>
        <Descriptions.Item label="Lana URL" span={3}>
          <a href={account.url} target="_blank" rel="noopener noreferrer">
            {account.url}
          </a>
        </Descriptions.Item>
        <Descriptions.Item label="Lana REF" span={3}>
          {account.ref}
        </Descriptions.Item>
        <Descriptions.Item label="CLABE" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("clabe", {
              initialValue: clabe ? clabe : "",
              rules: [
                {
                  required: true,
                  message: "CLABE is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Cacao ID" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("cacao_id", {
              initialValue: cacao_id ? cacao_id : "",
              rules: [
                {
                  required: true,
                  message: "Cacao ID is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
      <div style={{ height: "25px"}}>
        <Form.Item style={{float: 'right'}}>
          <Button style={{marginRight: '5px'}} onClick={() => close(false)}>Cancel</Button>
          <Button loading={loading} type="primary" onClick={onSubmit}>Save</Button>
        </Form.Item>
      </div>
    </>
  )
});

export default MX;
